import {makeStyles} from "tss-react/mui";

const useStylesActionPageSection = makeStyles()(theme => ({
    futureStatusInfoContainer: {
        backgroundColor: theme.palette.color2,
        color: "#fff",
    },
}))

export default useStylesActionPageSection;